import React from 'react';
import {
  Box,
  Button as RebassButton,
  ButtonProps as RebassButtonProps,
} from 'rebass';

type ButtonProps = Omit<RebassButtonProps, 'css'> & {
  icon?: React.FC;
};

export const Button: React.FC<ButtonProps> = ({ icon, children, ...props }) => {
  return (
    <RebassButton tx="buttons" {...props}>
      {icon && <Box as={icon} />}
      {children}
    </RebassButton>
  );
};
